import { Component } from "@angular/core";
import { NgOptimizedImage } from "@angular/common";
import { Button } from "primeng/button";
import { RouterLink } from "@angular/router";

@Component({
	selector: "app-forbidden",
	imports: [NgOptimizedImage, Button, RouterLink],
	templateUrl: "./forbidden.component.html"
})
export class ForbiddenComponent {}
